<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Pengaturan" />
      <Card class="dark:bg-dark-900">
        <template #content>
          <Tabs value="0" scrollable>
            <TabList>
              <Tab value="0" class="hidden md:flex">Metode Pembayaran</Tab>
              <Tab v-tooltip.top="{
                value: 'Metode Pembayaran',
                pt: {
                  arrow: {
                    style: {
                      borderBottomColor: 'var(--p-primary-color)'
                    }
                  },
                  text: '!bg-primary !text-primary-contrast !font-medium'
                }
              }" value="0" class="md:hidden">
                <i class="pi pi-credit-card"></i>
              </Tab>
              <Tab value="1" class="hidden md:flex">Tax & Service Charge</Tab>
              <Tab v-tooltip.top="{
                value: 'Tax & Service Charge',
                pt: {
                  arrow: {
                    style: {
                      borderBottomColor: 'var(--p-primary-color)'
                    }
                  },
                  text: '!bg-primary !text-primary-contrast !font-medium'
                }
              }" value="1" class="md:hidden">
                <i class="pi pi-percentage"></i>
              </Tab>
              <Tab value="2" class="hidden md:flex">Printer Setting</Tab>
              <Tab v-tooltip.top="{
                value: 'Printer Setting',
                pt: {
                  arrow: {
                    style: {
                      borderBottomColor: 'var(--p-primary-color)'
                    }
                  },
                  text: '!bg-primary !text-primary-contrast !font-medium'
                }
              }" value="2" class="md:hidden">
                <i class="pi pi-print"></i>
              </Tab>
            </TabList>
            <TabPanels class="dark:bg-dark-900">
              <TabPanel value="0">
                <MetodePembayaranTab />
              </TabPanel>
              <TabPanel value="1">
                <PengaturanDua />
              </TabPanel>
              <TabPanel value="2">
                <PrintTes />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </template>
      </Card>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import MetodePembayaranTab from '@/views/pages/setting/MetodePembayaranTab.vue';
import PengaturanDua from '@/views/pages/setting/PengaturanDuaTab.vue';
import PrintTes from './PrintTes.vue';
import { Card, Tabs, TabList, Tab, TabPanel, TabPanels, ConfirmDialog, Button, Toast } from 'primevue';
import ViewContainer from '@/components/ViewContainer.vue';

export default {
  name: "SettingView",
  components: {
    IndexView, PageTitle, MetodePembayaranTab, PengaturanDua, PrintTes, Card, Tabs, TabList, Tab, TabPanel, TabPanels, ConfirmDialog, Button, Toast, ViewContainer
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
